import React, { useState, useEffect } from 'react';
import API from '../services/api';
import "./AddTag.css";

const AddTag = () => {
    const [name, setName] = useState('');
    const [nodeId, setNodeId] = useState('');
    const [serverId, setServerId] = useState('');
    const [servers, setServers] = useState([]);
    const [tags, setTags] = useState([]);
    const [opcTags, setOpcTags] = useState([]); // تگ‌های دریافت‌شده از سرور OPC
    const [message, setMessage] = useState('');
    const [fetchingName, setFetchingName] = useState(false);
    const [loadingOpcTags, setLoadingOpcTags] = useState(false);

    useEffect(() => {
        const fetchServers = async () => {
            try {
                const response = await API.get('/servers/');
                setServers(response.data);
            } catch (error) {
                console.error('Failed to fetch servers:', error);
            }
        };

        const fetchTags = async () => {
            try {
                const response = await API.get('/tags/');
                setTags(response.data);
            } catch (error) {
                console.error('Failed to fetch tags:', error);
            }
        };

        fetchServers();
        fetchTags();
    }, []);

    const handleFetchTagName = async () => {
        if (!serverId || !nodeId) {
            setMessage('Please select a server and enter a Node ID.');
            return;
        }

        setFetchingName(true);
        try {
            const response = await API.post('/fetch-tag-name/', {
                server_id: serverId,
                node_id: nodeId,
            });
            if (response.data && response.data.name) {
                setName(response.data.name); // تنظیم Display Name به‌عنوان نام تگ
                setMessage('Tag name fetched successfully!');
            } else {
                setMessage('Failed to fetch tag name.');
            }
        } catch (error) {
            setMessage('Failed to fetch tag name.');
            console.error(error);
        }
        setFetchingName(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await API.post('/tags/', {
                name,
                node_id: nodeId,
                server: serverId,
            });
            setMessage('Tag added successfully!');
            setName('');
            setNodeId('');
            setServerId('');
            const updatedTags = await API.get('/tags/');
            setTags(updatedTags.data);
        } catch (error) {
            setMessage('Failed to add tag.');
            console.error(error);
        }
    };

    const handleFetchOpcTags = async () => {
        if (!serverId) {
            setMessage('Please select a server.');
            return;
        }

        setLoadingOpcTags(true);
        setMessage('Fetching OPC tags...');
        try {
            const response = await API.post('/browse-tags/', {
                server_id: serverId,
            });
            setOpcTags(response.data.tags);
            setMessage('OPC tags fetched successfully.');
        } catch (error) {
            setMessage('Failed to fetch OPC tags.');
            console.error(error);
        }
        setLoadingOpcTags(false);
    };

    return (
        <div className="container">
            <h1 className="title">Add Tag</h1>
            <form className="form">
                <div className="form-group">
                    <label className="label">Tag Name:</label>
                    <input
                        className="input"
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group">
                    <label className="label">Node ID:</label>
                    <input
                        className="input"
                        type="text"
                        value={nodeId}
                        onChange={(e) => setNodeId(e.target.value)}
                        required
                    />
                </div>
                <small className="small-text">
                    Examples for Node ID: <b>ns=4;i=2</b> (Numeric) or <b>ns=2;s=Pump_Status</b> (String)
                </small>
                <div className="form-group">
                    <label className="label">OPC Server:</label>
                    <select
                        className="select"
                        value={serverId}
                        onChange={(e) => setServerId(e.target.value)}
                        required
                    >
                        <option value="">Select a server</option>
                        {servers.map((server) => (
                            <option key={server.id} value={server.id}>
                                {server.name}
                            </option>
                        ))}
                    </select>
                </div>
            </form>
            <div className="button-container">
                <button className="button" onClick={handleFetchTagName} disabled={fetchingName}>
                    {fetchingName ? 'Fetching...' : 'Fetch Tag Name'}
                </button>
                <button className="button" onClick={handleSubmit}>
                    Add Tag
                </button>
                <button className="button" onClick={handleFetchOpcTags} disabled={loadingOpcTags}>
                    {loadingOpcTags ? 'Fetching...' : 'Fetch OPC Tags'}
                </button>
            </div>
            {message && <p className="message">{message}</p>}

            <h2 className="sub-title">Existing Tags</h2>
            <table className="table">
                <thead>
                    <tr>
                        <th>Tag Name</th>
                        <th>Node ID</th>
                        <th>Server ID</th>
                    </tr>
                </thead>
                <tbody>
                    {tags.map((tag) => (
                        <tr key={tag.id}>
                            <td>{tag.name}</td>
                            <td>{tag.node_id}</td>
                            <td>{tag.server}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <h2 className="sub-title">OPC Tags</h2>
            <table className="table">
                <thead>
                    <tr>
                        <th>Node ID</th>
                        <th>Display Name</th>
                        <th>Parents</th>
                        <th>Type</th>
                    </tr>
                </thead>
                <tbody>
                    {opcTags.map((tag, index) => (
                        <tr key={index}>
                            <td>{tag.node_id}</td>
                            <td>{tag.display_name}</td>
                            <td>{tag.parents || 'Root'}</td>
                            <td>{tag.type || 'Unknown'}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default AddTag;
